import React from "react";
import Header from "../Header";
import Navigation from "../Navigation";
import Alert from "../Utilities/Alert";
import { Helmet } from "react-helmet";
import { getLoggedUser } from "../../context/auth";
import moment from "moment";
import SaveButton from "../Controls/SaveButton";

const GlobalConfig = new window.globalConfig();
let loggedUser = {};
class App extends React.Component {
  constructor(props) {
    super();
    loggedUser = getLoggedUser();
    this.state = {
      title: "",
      listtitle: "",
      urllist: "",
      urlapi: "",
      urlsubmitapi: "",
      alertshow: false,
      isChanged: false,
      alerttype: "",
      alertmsg: "",
      imageFieldName: "",
      imageFieldExtension: "",
      imageMaxSize: 0,
      data: {},
      isUseHeading: true,
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleChange4Image = this.handleChange4Image.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
  }

  async componentDidMount() {
    this.getItemById(this.state.data._id);
  }

  componentDidUpdate = () => {
    // if user change data
    if (this.state.isChanged) {
      // warn user will lose the changes
      window.onbeforeunload = () => {
        return true;
      };
    } else {
      window.onbeforeunload = undefined;
    }
  };

  getItemById = async (id) => {
    this.setState({
      alertmsg: "Loading...",
      alerttype: "info",
      alertshow: true,
    });
    try {
      const that = this;
      var url = this.composeQueryUrlApi(id);
      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (item) {
          if (item && item.result === "OK") {
            if (item.data) {
              that.setState(
                {
                  data: item.data,
                  //Turn-off message
                  alertshow: false,
                },
                () => {
                  that.doSomethingAfterGetItemById();
                }
              );
            } else {
              // window.location.href = process.env.REACT_APP_URL_PAGE_NOT_FOUND;
              that.setState({
                alertshow: false,
              });
              that.setState({
                alertmsg: item.message
                  ? item.message
                  : GlobalConfig.REACT_APP_MSG_CONTENT_NOT_EXIST,
                alerttype: "error",
                alertshow: true,
              });
            }
          } else {
            that.setState({
              alertshow: false,
            });
            that.setState({
              alertmsg: item.message,
              alerttype: "error",
              alertshow: true,
            });
          }
        })
        .catch(function (error) {
          that.setState({
            alertshow: false,
          });
          that.setState({
            alertmsg: error,
            alerttype: "error",
            alertshow: true,
          });
        });
    } catch (err) {
      this.setState({
        alertshow: false,
      });
      this.setState({
        alertmsg: err.message,
        alerttype: "error",
        alertshow: true,
      });
    }
  };

  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error on getBase64: ", error);
    };
  }

  handleChange4Image(event) {
    // var id = event.target.name;
    // event.target.files[0];
    var files = event.target.files;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file.type == "image/jpeg" || file.type == "image/png") {
          // if (parseInt(files.size.split(" ")[0]) > this.state.imageMaxSize) {
          //   window.showAlert(
          //     "Error",
          //     "Does not allow image over " + this.state.imageMaxSize + " KB. Please upload another.",
          //     "error"
          //   );
          //   return;
          // }
          let filesBase64 = "";
          this.getBase64(file, (result) => {
            filesBase64 = result;
            const arrTemp = file.name.split(".");
            const fileExtension = arrTemp[arrTemp.length - 1];
            this.setState({
              isChanged: true,
              data: Object.assign({}, this.state.data, {
                [this.state.imageFieldName]: filesBase64,
                [this.state.imageFieldExtension]: fileExtension,
              }),
            });
          });
        } else {
          window.showAlert("Error", "Please choose PNG or JPG", "error");
        }
      }
    } else {
      this.setState({
        isChanged: true,
        data: Object.assign({}, this.state.data, {
          [this.state.imageFieldName]: "",
        }),
      });
    }
  }

  formatDate = (inputDate) => {
    const date = new Date(inputDate);

    // check date < 10 to add leading zeros
    const getDate = date.getDate().toString();
    const dateCheck = getDate[1] ? getDate : "0" + getDate[0];

    // check month < 10 to add leading zeros
    const getMonth = date.getMonth() + 1;
    const monthString = getMonth.toString();
    const monthCheck = monthString[1] ? monthString : "0" + monthString[0];

    if (!isNaN(date.getTime())) {
      // Months use 0 index.
      return monthCheck + "/" + dateCheck + "/" + date.getFullYear();
    }
  };

  handleDateChange(date) {
    const getDate = moment(date).format("L");
    if (date) {
      this.setState({
        isChanged: true,
        data: Object.assign({}, this.state.data, {
          testDate: getDate,
        }),
      });
    }
  }

  handleChange(event) {
    var id = event.target.name;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({
      isChanged: true,
      data: Object.assign({}, this.state.data, {
        [id]: value,
      }),
    });
  }

  handleImageChange(files) {
    //files
    //   {
    //     "name": "logo_react.jpg",
    //     "type": "image/jpeg",
    //     "size": "57 kB",
    //     "base64": "data:image/jpeg;base64,/9j/4AAQSkZJRg...",
    //     "file": {}
    //   }
    // ]
    if (files) {
      if (files.type == "image/jpeg" || files.type == "image/png") {
        // if (parseInt(files.size.split(" ")[0]) > this.state.imageMaxSize) {
        //   window.showAlert(
        //     "Error",
        //     "Does not allow image over 1MB. Please upload another.",
        //     "error"
        //   );
        //   return;
        // }
        const arrTemp = files.name.split(".");
        const fileExtension = arrTemp[arrTemp.length - 1];
        this.setState({
          isChanged: true,
          data: Object.assign({}, this.state.data, {
            [this.state.imageFieldName]: files.base64,
            [this.state.imageFieldExtension]: fileExtension,
          }),
        });
      } else {
        window.showAlert("Error", "Please choose PNG or JPG", "error");
      }
    } else {
      this.setState({
        isChanged: true,
        data: Object.assign({}, this.state.data, {
          [this.state.imageFieldName]: "",
        }),
      });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.checkSomethingBeforeSave() === false) {
      return;
    }

    await this.updateDataBeforeSaving();

    this.setState(
      {
        data: Object.assign({}, this.state.data, {
          modifiedUserId: loggedUser._id,
        }),
        //If the component is edit walnut test,we will have 2 loading cases (Save button and Save & Print button)
        [this.state.editWalnut === true && this.state.print === true
          ? "printLoading"
          : "loading"]: true,
      },
      () => {
        try {
          const that = this;
          const api =
            this.state.urlsubmitapi === null ||
            this.state.urlsubmitapi === undefined ||
            this.state.urlsubmitapi === ""
              ? this.state.urlapi
              : this.state.urlsubmitapi;
          const requestOptions = {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(this.state.data),
          };
          const url = api + this.state.data._id;
          fetch(url, requestOptions)
            .then(function (response) {
              return response.json();
            })
            .then(function (resultObject) {
              //If updated successful
              if (resultObject && resultObject.result === "OK") {
                that.setState({
                  alertshow: false,
                  isChanged: false,
                });
                window.showAlert("", "Save successful!", "");

                that.doSomethingAfterSaved(resultObject);
              }
              //If failed, show error
              else {
                that.setState({
                  alertshow: false,
                });
                that.setState({
                  alertmsg: resultObject.message,
                  alerttype: "error",
                  alertshow: true,
                });
              }
              that.hideLoading();
            })
            .catch(function (error) {
              that.setState({
                alertshow: false,
              });
              that.setState({
                alertmsg: error,
                alerttype: "error",
                alertshow: true,
              });
              that.hideLoading();
            });
        } catch (err) {
          this.setState({
            alertshow: false,
          });
          this.setState({
            alertmsg: err.message,
            alerttype: "error",
            alertshow: true,
          });
          this.hideLoading();
        }
      }
    );
  };

  hideLoading = () => {
    this.setState({
      [this.state.editWalnut === true && this.state.print === true
        ? "printLoading"
        : "loading"]: false,
    });
  };

  checkSomethingBeforeSave = () => {
    return true;
  };

  updateDataBeforeSaving = async () => {};

  render() {
    const title = this.defaultTitle();
    return (
      <>
        <Helmet>
          <title>{title + " | " + process.env.REACT_APP_SITE_TITLE}</title>
        </Helmet>
        <section className="body">
          <Header></Header>
          <div className="inner-wrapper">
            <Navigation
              navRoute={this.props.navRoute}
              location={this.props.location}
            ></Navigation>

            <section role="main" className="content-body">
              <header className="page-header">
                <h2>{title}</h2>
                <div className="right-wrapper pull-right">
                  <ol className="breadcrumbs">
                    <li>
                      <a href="/">
                        <i className="fa fa-home"></i>
                      </a>
                    </li>
                    {this.state.urllist == "" || this.state.listtitle == "" ? (
                      ""
                    ) : (
                      <li>
                        <a href={this.state.urllist}>{this.state.listtitle}</a>
                      </li>
                    )}
                    {this.extendBreadcrumb()}
                    <li>
                      <span>{this.getTitle()}</span>
                    </li>
                  </ol>
                  <a className="sidebar-right-toggle" data-open="sidebar-right">
                    <i className="fa fa-chevron-left"></i>
                  </a>
                </div>
              </header>
              <div className="row">
                <div className="col-md-12">
                  <form
                    onSubmit={this.handleSubmit}
                    id="form"
                    className="form-horizontal"
                  >
                    <section className="panel">
                      {this.state.isUseHeading ? (
                        <header className="panel-heading">
                          <h2 className="panel-title">
                            {this.state.sectionTitle == undefined
                              ? "Basic Information"
                              : this.state.sectionTitle}
                          </h2>
                        </header>
                      ) : (
                        ""
                      )}
                      {this.renderForm()}
                      {this.renderFooter()}
                    </section>
                  </form>
                  {this.state.alertshow === true ? (
                    <Alert
                      message={this.state.alertmsg}
                      type={this.state.alerttype}
                      show={this.state.alertshow}
                      showBtnClose={true}
                    ></Alert>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.extraFooterRender()}
            </section>
          </div>
        </section>
      </>
    );
  }

  renderForm = () => {
    return "";
  };

  extraFooterRender = () => {
    return "";
  };

  renderFooter = () => {
    return (
      <footer className="panel-footer">
        <div className="row">
          <div className="col-sm-9 col-sm-offset-3">
            <SaveButton loading={this.state.loading} />
            {this.state.urllist === null ||
            this.state.urllist === undefined ||
            this.state.urllist === "" ? (
              ""
            ) : (
              <a
                href={this.state.urllist}
                title="Back to list"
                className="btn btn-primary"
              >
                <i className="fa fa-backward fa-lg"></i> Back
              </a>
            )}
            {this.extendButtons()}
          </div>
        </div>
      </footer>
    );
  };

  extendBreadcrumb = () => {
    return "";
  };

  extendButtons = () => {
    return "";
  };

  defaultTitle = () => {
    return "Edit - " + this.getTitle();
  };

  getTitle = () => {
    return "";
  };

  doSomethingAfterGetItemById = () => {};

  doSomethingAfterSaved = () => {};

  composeQueryUrlApi = (id) => {
    return this.state.urlapi + id;
  };
}
export default App;
